/*
Hinweis: Für die Produktbilder wird OWL Carousel (2019) verwendet.
Für die Zoom-Ansicht kommt Fancybox 3 (commercial license) zum Einsatz.
Das Ganze wird mit custom JavaScript ergänzt, um die beiden Module zu verbinden.
*/

/* disable url hash feature globally */
$.fancybox.defaults.hash = false;

/**
 * inits owl carousel and fancybox with custom optimized features
 * @param wrapperSelector
 * @param owlCarouselSelector
 * @param thumbnailsSelector
 * @param optsIfOneImage	options will be merged with defaults
 * @param optsIfMoreImages	options will be merged with defaults
 */
function shopInitOwlCarouselAndFancyBox( wrapperSelector, owlCarouselSelector, thumbnailsSelector, optsIfOneImage, optsIfMoreImages, optsThumbnails ) {

	optsIfOneImageDefaults = {
		items: 1,
		margin: 0,
		loop: false,
		nav: false,
		dots: false,
		lazyLoad: true,
		mouseDrag: false,
		touchDrag: false,
		pullDrag: false,
		autoHeight: false
	};

	optsIfMoreImagesDefaults = {
		items: 1,
		margin: 30,
		loop: false,
		nav: true,
		dots: false,
		lazyLoad: true,
		autoHeight: false
	};

	optsThumbnailsDefaults = {
		items: 5,
		margin: 10,
		loop: false,
		nav: false,
		dots: true,
		lazyLoad: true,
		// mouseDraggable: false,
		responsive: {
			0: {
				items: 3
			},
			480: {
				items: 5
			}
		}
	};

	var optionsIfOneImage = $.extend( {}, optsIfOneImageDefaults, optionsIfOneImage ),
		optionsIfMoreImages = $.extend( {}, optsIfMoreImagesDefaults, optsIfMoreImages ),
		optionsThumbnails = $.extend( {}, optsThumbnailsDefaults, optsThumbnails ),
		hasThumbnails = typeof(thumbnailsSelector) !== 'undefined',
		$owlCarousel = $(wrapperSelector).find(owlCarouselSelector).eq(0),
		$thumbnailsCarousel = $(wrapperSelector).find(thumbnailsSelector).eq(0),
		activeClass = 'active';

	/* Produktbilder (Normalgröße) mit Index-Nummerierung versehen, bevor owlCarousel die items klont */
	$owlCarousel.find('a').each(function(i){
		$(this).attr('data-index', i);
	});

	// =====================================================================================================
	// OwlCarousel
	// =====================================================================================================

	/* Produktbilder und ggf. Thumbnails einblenden, sobald OWL initialisiert ist, damit nichts wackelt */
	$owlCarousel.on('initialized.owl.carousel', function () {
		// setCss3Style($(wrapperSelector).get(0), 'transition', 'opacity 5000ms linear');
		$(wrapperSelector)
			.css({
				WebkitTransition : 'opacity 200ms linear',
				MozTransition    : 'opacity 200ms linear',
				MsTransition     : 'opacity 200ms linear',
				OTransition      : 'opacity 200ms linear',
				transition       : 'opacity 200ms linear'
			})
			.css('opacity', 1);
		if (hasThumbnails) {
			$thumbnailsCarousel.find('li').eq(0).addClass(activeClass);
		}
	});

	/* initialize owl carousel on medium sized product images, but with different options, when there is one or more images */
	if ($owlCarousel.children().length > 1) {
		$owlCarousel.owlCarousel( optionsIfMoreImages );
	} else {
		$owlCarousel.owlCarousel( optionsIfOneImage );
	}

	// =====================================================================================================
	// handle changes in owl carousel -> mark thumbnail
	// =====================================================================================================
	if (hasThumbnails) {
		$owlCarousel.on('changed.owl.carousel', function (e) {
			// workaround:
			setTimeout(function () {
				var index = $owlCarousel.find('.owl-item.active a').attr('data-index'); // get active image index
				$thumbnailsCarousel.find('li').removeClass(activeClass).eq(index).addClass(activeClass); // set thumbnail marker
				// scroll thumbnails, if active thumbnail is not visible
				if (!$thumbnailsCarousel.find('li').eq(index).parent().hasClass('active')) {
					$thumbnailsCarousel.trigger('to.owl.carousel', index);
				}
			}, 1);
		});
	}



	// =====================================================================================================
	// fancybox
	// =====================================================================================================

	$().fancybox({
		selector: wrapperSelector + ' .owl-item:not(.cloned) a',
		backFocus: false,
		hideScrollbar: false,
		loop: false,
		idleTime: false,
		iframe: {preload: false},
		buttons: [
			'zoom',
			'close'
		],
		btnTpl: {
			zoom:		'<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}">' +
						'</button>',
			close:		'<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
						'</button>',
			arrowLeft:	'<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
						'<div></div>' +
						'</button>',
			arrowRight:	'<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
						'<div></div>' +
						'</button>'
		},
		lang: 'de',
		afterShow: function (instance, current) {
			var owl = $(owlCarouselSelector),
				pos = current.pos,
				index = current.index;
			owl.trigger('to.owl.carousel', index);
			/* workaround to reset owl carousel start position to non-cloned element, to prevent fancybox-close-animation from "failing" */
			if (pos != index) {
				owl.trigger('to.owl.carousel', index);
			}
		}
	});

	// =====================================================================================================
	// Attach custom click event on cloned elements,
	// trigger click event on corresponding link.
	// =====================================================================================================
	$(wrapperSelector).on('click', '.owl-item.cloned a', function (e) {
		var $slides = $(this)
			.closest('.owl-item')
			.siblings('.owl-item:not(.cloned)');
		$slides
			.eq(($(this).attr('data-index') || 0) % $slides.length)
			.find('a')
			.trigger('click.fb-start', {$trigger: $(this)});
		return false;
	});

	// =====================================================================================================
	// make thumbnails also an owl carousel
	// =====================================================================================================
	if (hasThumbnails) {
		$thumbnailsCarousel.owlCarousel( optionsThumbnails );
	}

	// =====================================================================================================
	// handle clicks on thumbnails
	// =====================================================================================================
	if (hasThumbnails) {
		$thumbnailsCarousel.find('li img').on('click', function () {
			var self = $(this),
				index = self.parent().parent().index(), // div[owl-item] > li > img
				$owl = $(wrapperSelector).find(owlCarouselSelector).eq(0);
			$owl.trigger('to.owl.carousel', index);
		});
	}

}





$(function() {

	// _product-images.php
	if ($('.shop-product-images-wrapper').length) {
		shopInitOwlCarouselAndFancyBox(
			'.shop-product-images-wrapper',
			'.owl-carousel',
			'.shop-product-images-thumbnails',
			undefined,
			undefined
		);
	}

	// _product-image-gallery.php
	if ($('.page-product-image-gallery-wrapper').length) {
		$(function(){
			shopInitOwlCarouselAndFancyBox(
				'.page-product-image-gallery-wrapper',
				'.page-product-image-gallery',
				undefined,
				undefined,
				{
					items: 6,
					loop: false,
					dots: true,
					nav: false,
					responsive : {
						0: {
							items: 2
						},
						568: {
							items: 3
						},
						667: {
							items: 4
						},
						768: {
							items: 5
						},
						992: {
							items: 6
						}
					}
		        }
			);
		});
	}

});




